module.exports = __webpack_public_path__ + "static/img/Software Architecture OFMIS.05a6637a.webp";